import { useEffect, useState } from "react";
import axios from "axios";

export default function useSearchApi(searchTerm) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Get API Base URL from env
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    // empty or less than 3 letters → clear results
    if (!searchTerm || searchTerm.trim().length < 3) {
      setResults([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      try {
        // ✅ Using env URL
        const res = await axios.get(
          `${API_BASE_URL}MasterAPI/TestSearchMaster?SearchText=${searchTerm}`
        );

        // API returns array OR object — always convert to array safely
        setResults(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Search API Error:", err);
        setResults([]);
      }

      setLoading(false);
    };

    fetchData();
  }, [searchTerm, API_BASE_URL]);

  return { results, loading };
}